export const getIsPartOfColleagueDesigns = (): boolean =>
  window.location.search.includes('isPartOfColleagueApp')
